module.exports = __webpack_public_path__ + "files/aae304b7e096f3c7b5aa87e046067f6d.svg";